// Per-organization feature flags (ADR-0173 fase 2, PR-1).
//
// `organizations.config` is `.strict()` (org-config.ts) and audited as one
// blob, so flags do not live there: they are rows in
// `organization_feature_flags`, one per (organization, key), toggled only
// by a platform admin and audited one by one. The engine owns the closed
// set of keys so core-api, ai-svc and the dashboard agree on the names
// (api-types derives its enum from here — wire-enums-derive-from-engine).
import { z } from "zod";
export const ORGANIZATION_FEATURE_FLAG_KEYS = [
    /** The org may upload context sources (policy, checklist, guide). */
    "context_ingest",
    /** analyze-block sends the org's active context version to the model. */
    "context_inject",
    /** The item verdict is derived from per-rule results (deriveItemVerdict). */
    "context_derive_verdict",
    /** Activating a context version needs a second person (D4). */
    "context_four_eyes",
];
export const organizationFeatureFlagKeySchema = z.enum(ORGANIZATION_FEATURE_FLAG_KEYS);
export function emptyFeatureFlags() {
    return Object.fromEntries(ORGANIZATION_FEATURE_FLAG_KEYS.map((k) => [k, false]));
}
/** Folds the rows that exist into the full record (absent row = false). */
export function featureFlagsFromRows(rows) {
    const out = emptyFeatureFlags();
    for (const row of rows) {
        const parsed = organizationFeatureFlagKeySchema.safeParse(row.flagKey);
        if (parsed.success)
            out[parsed.data] = row.enabled;
    }
    return out;
}
//# sourceMappingURL=feature-flags.js.map